/**
 * A missing subscription row is treated as subscribed to every channel.
 * When consent is required, the signup choice has to be written explicitly
 * or the customer is subscribed without an opt-in.
 */
export function consentMarketingSubscriptions(optedIn: boolean): Partial<App.SubscriptionPreferencesV2> {
  if (!optedIn) {
    return {
      emailSubscribed: false,
      smsSubscribed: false,
      appPushSubscribed: false,
      todaysEscapesSubscribed: false,
      curatedCollectionSubscribed: false,
      myJourneySubscribed: false,
    }
  }

  return {
    emailSubscribed: true,
    smsSubscribed: false,
    appPushSubscribed: false,
    todaysEscapesSubscribed: true,
    curatedCollectionSubscribed: true,
    myJourneySubscribed: false,
    todaysEscapesCadence: 'DAILY',
  }
}
